"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.6.0'] && _();
}
catch (e) { }
